import { action, makeObservable, observable } from 'mobx'

export const MIN_CARD_WIDTH = 190
export const MIN_CARD_TITLE_ROW_HEIGHT = 19
export const CARD_ROW_HEIGHT = 18

export default class PermitCalendarCardStore {
  @observable public shouldAlignStatusToEnd: boolean = false
  @observable public shouldShowContextMenu: boolean = true
  @observable public sharedLocationLink: string = ''

  public constructor() {
    makeObservable(this)
  }

  @action.bound
  public setStatusAlignment(shouldAlignToTheEnd: boolean) {
    this.shouldAlignStatusToEnd = shouldAlignToTheEnd
  }

  @action.bound
  public setSharedLocationLink(value: string) {
    this.sharedLocationLink = value
  }

  @action.bound
  public toggleContextMenu() {
    this.shouldShowContextMenu = !this.shouldShowContextMenu
  }
}
